import { CameraDetail } from '@hakimo-ui/hakimo/types';
import { useCanUpdateCamera } from '@hakimo-ui/hakimo/util';
import { DetailSection, Toggle } from '@hakimo-ui/shared/ui-base';
import { useUpdatePlayback } from './update-fields/useUpdatePlayback';

interface Props {
  camera: CameraDetail;
}

export function SettingSectionActions(props: Props) {
  const { camera } = props;
  const canUpdateCamera = useCanUpdateCamera();

  const [playbackEnabled, togglePlayback] = useUpdatePlayback(
    camera.id,
    camera.isPlaybackEnabled ?? false
  );

  if (!canUpdateCamera) {
    return null;
  }

  return (
    <DetailSection title="Actions">
      <div className="flex items-center justify-between gap-4 py-4">
        <div className="flex flex-col gap-3">
          <span className="text-onlight-text-2 dark:text-ondark-text-2 text-sm">
            Playback
          </span>
          <Toggle enabled={playbackEnabled} onChange={togglePlayback} />
        </div>
      </div>
    </DetailSection>
  );
}
